// components/industry-templates/TelecomEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Signal, Smartphone, Wifi, Radio } from 'lucide-react';

export const TelecomEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* 5G Technology */}
      {industryData?.network_tech && (
        <Card className="border-0 bg-gradient-to-br from-purple-600/20 to-blue-600/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Signal className="w-8 h-8" style={{ color: theme.primary }} />
              Network Technologies
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.network_tech.map((tech: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl">
                  <h3 className="text-xl font-bold text-white mb-2">{tech.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{tech.description}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{tech.generation}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Telecom Providers */}
      {industryData?.providers && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Participating Providers</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-4 gap-3">
              {industryData.providers.map((provider: string, idx: number) => (
                <div key={idx} className="p-3 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">📡</div>
                  <p className="text-white font-medium text-sm">{provider}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
